(function () {
  // The header search dropdown (Linear ENG-370). It replaces the full-screen overlay
  // (SearchPageCtrl) and the older WaxTrackerCtrl autocomplete. Markup: shared/_search_dropdown.html.erb,
  // rendered once per header and once on the wax tracker search pages, so the controller is
  // instantiated more than once per page: nothing here binds to a fixed id.
  //
  // Requests it sends (contract: the SearchController header comment):
  //   GET    /search/suggest   q (empty = idle state), correct=1, raw=1 after "Search instead for"
  //   GET    /waxtracker/search-suggestions   q, page=0: the legacy endpoint, asked only when
  //                            /search/suggest answers succeed:false (the v2 read switch is OFF in prod
  //                            today, and during a rollback). Its rows are shown as plain box rows.
  //   POST   /search/submit    JSON {q, kind, box_id?, <filters>?} + X-CSRF-Token, fetch keepalive,
  //                            fired BEFORE the navigation, which never carries submitted=1
  //   DELETE /search/recent    the "Clear" link on Recent, + X-CSRF-Token
  //
  // Every string that a person typed or an admin curated (q, corrected_query, recent, trending,
  // examples, sport names, box names, the unavailable message) reaches the DOM through ng-bind or
  // textContent only, never ng-bind-html or {{ }}. Server-rendered text that echoes q lives in an
  // ng-non-bindable element (data-ws-sd-initial) and is read here with getAttribute.
  var SUGGEST_URL = '/search/suggest';
  var LEGACY_URL = '/waxtracker/search-suggestions';
  var SUBMIT_URL = '/search/submit';
  var RECENT_URL = '/search/recent';
  var DEBOUNCE_MS = 220;
  // While /search/suggest says v2 is unavailable (read switch off, breaker open), go straight to
  // the legacy endpoint for V2_DOWN_MS and type at the pre-ENG-370 600 ms pace: the legacy
  // endpoint writes a search_histories row per page-0 call, so a 220 ms pace would log every
  // prefix and add a second round trip per keystroke.
  var LEGACY_DEBOUNCE_MS = 600;
  var V2_DOWN_MS = 60000;
  var v2_down_until = 0;
  function v2Down() { return Date.now() < v2_down_until; }
  var IDLE_TTL_MS = 30000;
  var PLACEHOLDER_MS = 3500;
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var MAX_BOXES = 6;
  var LEAVE_GUARD_MS = 3000;
  var instance_seq = 0;

  function csrfToken() {
    return $('meta[name="csrf-token"]').attr('content');
  }

  function visit(url) {
    if (window.Turbolinks && window.Turbolinks.visit) {
      window.Turbolinks.visit(url);
    } else {
      window.location.assign(url);
    }
  }

  // Fire and forget: the page navigates right after, so keepalive keeps the request alive.
  // sendBeacon cannot carry the CSRF header.
  function logSubmit(q, kind, extra) {
    if (!q || !window.fetch) return;
    var body = { q: q, kind: kind };
    // No filters are sent: a Recent entry replays only q, so a recorded filter would promise
    // something the next click does not do. The "q in <Sport>" row logs its q unfiltered too.
    extra = extra || {};
    if (extra.box_id) body.box_id = extra.box_id;
    try {
      window.fetch(SUBMIT_URL, {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': csrfToken() || ''
        },
        body: JSON.stringify(body)
      }).catch(function () {});
    } catch (e) {}
  }

  function words(text) {
    return String(text || '')
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
  }

  // The name split into runs, with the leading part of every word that starts with a query
  // word marked bold. Rendered as spans with ng-bind, so no markup is ever built from the name.
  function highlight(name, tokens) {
    var parts = [];
    String(name || '').split(/(\s+)/).forEach(function (piece) {
      if (!piece) return;
      var norm = piece.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
      var best = '';
      if (!/^\s+$/.test(piece)) {
        tokens.forEach(function (t) {
          if (norm.indexOf(t) === 0 && t.length > best.length) best = t;
        });
      }
      if (!best) {
        parts.push({ t: piece, b: false });
        return;
      }
      var seen = 0, i = 0;
      while (i < piece.length && seen < best.length) {
        if (/[a-z0-9]/i.test(piece.charAt(i))) seen++;
        i++;
      }
      parts.push({ t: piece.slice(0, i), b: true });
      if (i < piece.length) parts.push({ t: piece.slice(i), b: false });
    });
    return parts;
  }

  function formatDate(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || '');
    if (!m) return '';
    return MONTHS[Number(m[2]) - 1] + ' ' + Number(m[3]) + ', ' + m[1];
  }

  // true when the YYYY-MM-DD release date is after the visitor's today. Compared as date
  // strings, so a UTC-midnight parse never flips the label a few hours early or late.
  function isUpcoming(iso) {
    var m = /^(\d{4}-\d{2}-\d{2})/.exec(iso || '');
    if (!m) return false;
    var now = new Date();
    var today = now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).slice(-2) + '-' + ('0' + now.getDate()).slice(-2);
    return m[1] > today;
  }

  var currency = (window.Intl && Intl.NumberFormat) ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }) : null;

  function formatPrice(value) {
    if (value === null || value === undefined || isNaN(Number(value))) return '';
    return currency ? currency.format(Number(value)) : '$' + Number(value).toFixed(2);
  }

  function plural(n, one, many) {
    return n + ' ' + (n === 1 ? one : many);
  }

  // price_7d is a plain array of numbers, oldest first. Returns the polyline points of a 64x22
  // box, built here from numbers only.
  function sparkline(series, change) {
    if (!Array.isArray(series)) return null;
    var values = series.map(Number).filter(function (v) { return isFinite(v); });
    if (values.length < 2) return null;
    var min = Math.min.apply(null, values), max = Math.max.apply(null, values);
    var span = max - min, w = 64, h = 22, pad = 2;
    var points = values.map(function (v, i) {
      var x = pad + (w - 2 * pad) * i / (values.length - 1);
      var y = span === 0 ? h / 2 : h - pad - (h - 2 * pad) * (v - min) / span;
      return x.toFixed(1) + ',' + y.toFixed(1);
    }).join(' ');
    var trend = typeof change === 'number' ? change : values[values.length - 1] - values[0];
    return { points: points, cls: trend > 0 ? 'up' : (trend < 0 ? 'down' : 'flat') };
  }

  function decorateBox(row, ctx) {
    var option = { kind: 'box', id: row.id, slug: row.slug, name: row.name };
    option.thumb = row.box_image || ctx.no_image;
    option.case_label = row.case_quantity > 1 ? '×' + row.case_quantity : '';
    option.is_hot = row.is_hot === true;
    option.parts = ctx.upc ? [{ t: row.name || '', b: false }] : highlight(row.name, ctx.tokens);
    option.upc_match = !!ctx.upc;
    var meta = [row.sport_type_name, row.box_type_name];
    if (ctx.upc) {
      var typed = String(ctx.query || '').replace(/\D/g, '');
      var upcs = Array.isArray(row.upcs) ? row.upcs : [];
      var hit = upcs.filter(function (u) { return typed && String(u).replace(/\D/g, '').indexOf(typed) !== -1; })[0] || upcs[0];
      if (hit) meta.push('UPC ' + hit);
    } else if (row.release_date) {
      // "Releasing this week" spans the whole week, so it holds days already gone (QA ENG-354 bug 5).
      meta.push((ctx.releasing ? (isUpcoming(row.release_date) ? 'Releases ' : 'Released ') : '') + formatDate(row.release_date));
    } else if (row.release_text) {
      meta.push(row.release_text);
    }
    if (ctx.releasing && row.retailers_in_stock > 0) {
      meta.push(plural(row.retailers_in_stock, 'retailer', 'retailers') + ' in stock');
    }
    if (row.retailers_in_stock === 0) meta.push('Out of stock');
    option.meta = meta.filter(Boolean).join(' · ');
    option.price = formatPrice(row.avg_price);
    var change = typeof row.price_7d_change_percent === 'number' ? row.price_7d_change_percent : null;
    if (change === null) {
      option.delta = '';
      option.delta_cls = 'flat';
    } else {
      option.delta = (change > 0 ? '+' : (change < 0 ? '−' : '')) + Math.abs(change).toFixed(1) + '%';
      option.delta_cls = change > 0 ? 'up' : (change < 0 ? 'down' : 'flat');
    }
    option.spark = sparkline(row.price_7d, change);
    return option;
  }

  // One handler pair for the whole page, bound once: the pack loads once and Turbolinks keeps it.
  if (!window.wsSearchDropdownBound) {
    window.wsSearchDropdownBound = true;

    // "/" focuses the header search from anywhere outside a text field.
    document.addEventListener('keydown', function (e) {
      if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey || e.defaultPrevented) return;
      var el = document.activeElement, tag = el && el.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (el && el.isContentEditable)) return;
      var inputs = document.querySelectorAll('[data-ws-search] .ws-sd-input');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].offsetParent !== null) {
          e.preventDefault();
          inputs[i].focus();
          inputs[i].select();
          return;
        }
      }
    });

    // A press outside a dropdown closes it (the dimmed page counts as outside).
    var outside = function (e) {
      var roots = document.querySelectorAll('[data-ws-search]');
      for (var i = 0; i < roots.length; i++) {
        if (!roots[i].contains(e.target)) roots[i].dispatchEvent(new CustomEvent('ws-search:close'));
      }
    };
    document.addEventListener('mousedown', outside, true);
    document.addEventListener('touchstart', outside, true);

    // The dimmer lives on <body>; never let it into a Turbolinks cache snapshot.
    document.addEventListener('turbolinks:before-cache', function () {
      var dims = document.querySelectorAll('.ws-sd-dim');
      for (var i = 0; i < dims.length; i++) dims[i].parentNode.removeChild(dims[i]);
      // Defensive (layouts/application sets turbolinks-cache-control no-cache today): never
      // cache rendered rows: on restore angular_app.js would recompile the snapshot, and ng-if
      // would take the rendered panel as its template (rows doubled, stale text interpolated).
      // ng-if keeps its own template on the comment anchor, so removing the panel is safe.
      var panels = document.querySelectorAll('[data-ws-search] .ws-sd-panel');
      for (var j = 0; j < panels.length; j++) panels[j].parentNode.removeChild(panels[j]);
      var roots = document.querySelectorAll('[data-ws-search].is-open');
      for (var k = 0; k < roots.length; k++) roots[k].classList.remove('is-open');
    });
  }

  app.controller('SearchDropdownCtrl', [
    "$scope", '$element', '$http', '$timeout', '$q',
    function ($scope, $element, $http, $timeout, $q) {
      var root = $element[0];
      var input = root.querySelector('.ws-sd-input');
      var uid = ++instance_seq;
      var search_url = root.getAttribute('data-ws-sd-search-url') || '/waxtracker/search';
      // The /search page (ENG-372) is served: a scope row opens it filtered by sport id.
      var results_page = search_url.indexOf('/search') === 0;
      var no_image = root.getAttribute('data-ws-sd-no-image') || '';
      var default_placeholder = input ? input.getAttribute('placeholder') : '';
      var debounce_timer = null, dim = null, suppress_open = false;
      // Two channels, so an idle load (warm-up) never aborts a typed query and vice versa.
      var channels = { idle: { seq: 0, canceller: null }, query: { seq: 0, canceller: null } };
      var origin_kind = null;       // 'trending' after a chip filled the field; cleared by typing
      var leaving_until = 0;        // a navigation is under way: repeated Enter / clicks are ignored
      var examples = [], example_index = 0;

      $scope.list_id = 'ws-sd-list-' + uid;
      $scope.q = '';
      $scope.open = false;
      $scope.view = 'idle';          // idle | query
      $scope.status = 'loading';     // loading | ready (query view)
      $scope.pending = false;        // typed, request not answered yet
      $scope.notice = null;          // {type: 'unavailable' | 'failed', message}
      $scope.data = null;            // the last /search/suggest answer for a keyword
      $scope.idle = { loaded: false, loading: false, at: 0, recent: [], trending: [], releasing: [] };
      $scope.recent_opts = [];
      $scope.trending_opts = [];
      $scope.scope_opts = [];
      $scope.box_opts = [];
      $scope.box_heading = '';
      $scope.all_opt = null;
      $scope.options = [];
      $scope.active = -1;
      $scope.active_id = undefined;
      $scope.announce = '';
      $scope.clear_error = '';
      $scope.raw = false;

      // applyData-free: the config is read from data-* attributes. The initial query sits in an
      // ng-non-bindable element, so Angular never interpolates it.
      var seed = root.querySelector('[data-ws-sd-initial]');
      if (seed) $scope.q = seed.getAttribute('data-ws-sd-initial') || '';

      function typed() {
        return String($scope.q || '').replace(/\s+/g, ' ').trim();
      }

      function optionId(n) {
        return 'ws-sd-' + uid + '-o' + n;
      }

      // The query a click, Enter or "See all" searches for: the corrected one when the visible
      // answer is a correction of exactly what is typed, otherwise what is typed.
      function searchQuery() {
        var d = $scope.data, t = typed();
        if (!$scope.pending && $scope.view === 'query' && d && d.is_corrected && d.corrected_query &&
            String(d.query || '').toLowerCase() === t.toLowerCase()) {
          return d.corrected_query;
        }
        return t;
      }

      function rebuild() {
        var list = [];
        function add(group) {
          group.forEach(function (o) {
            o.idx = list.length;
            o.dom_id = optionId(list.length);
            list.push(o);
          });
        }
        if ($scope.view === 'idle') {
          add($scope.recent_opts);
          add($scope.trending_opts);
          add($scope.box_opts);
        } else {
          add($scope.scope_opts);
          add($scope.box_opts);
          if ($scope.all_opt) add([$scope.all_opt]);
        }
        $scope.options = list;
        if ($scope.active >= list.length) $scope.active = -1;
        syncActive();
      }

      function syncActive() {
        var o = $scope.options[$scope.active];
        $scope.active_id = o ? o.dom_id : undefined;
        if (o) {
          $timeout(function () {
            var el = document.getElementById(o.dom_id);
            if (el && el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
          });
        }
      }

      function applyIdle() {
        var idle = $scope.idle;
        $scope.recent_opts = idle.recent.map(function (r) {
          // A recent replays as its query only: the legacy page cannot apply its filters.
          return { kind: 'recent', query: r.query };
        });
        $scope.trending_opts = idle.trending.map(function (t) { return { kind: 'trending', query: t.query }; });
        $scope.box_heading = 'Releasing this week';
        $scope.box_opts = idle.releasing.map(function (b) {
          return decorateBox(b, { tokens: [], no_image: no_image, releasing: true });
        });
        $scope.scope_opts = [];
        $scope.all_opt = null;
        rebuild();
      }

      function showIdle() {
        $scope.view = 'idle';
        $scope.pending = false;
        $scope.raw = false;
        $scope.announce = '';
        $scope.fallback = false;
        $scope.notice = null;
        applyIdle();
        // A load already in flight (warm() on hover, then focus) is kept, not aborted and resent.
        if ($scope.idle.loading) return;
        if (!$scope.idle.loaded || Date.now() - $scope.idle.at > IDLE_TTL_MS) loadIdle();
      }

      function abortChannel(name) {
        var ch = channels[name];
        ch.seq++;
        if (ch.canceller) {
          ch.canceller.resolve();
          ch.canceller = null;
        }
        if (name === 'idle') $scope.idle.loading = false;
      }

      function abortInflight() {
        abortChannel('query');
      }

      // One GET on a channel; a newer request on the same channel aborts this one and its answer
      // is dropped. done(err, body).
      function request(channel, url, params, done) {
        abortChannel(channel);
        var ch = channels[channel];
        var id = ch.seq;
        ch.canceller = $q.defer();
        $http.get(url, {
          params: params,
          timeout: ch.canceller.promise,
          headers: { 'Accept': 'application/json' }
        }).then(function (resp) {
          if (id === ch.seq) done(null, resp.data);
        }, function () {
          if (id === ch.seq) done(true);
        });
      }

      // loading is set after request(): its abortChannel('idle') clears the flag, and set before
      // it the flag would read false for the whole time this load is in flight.
      function loadIdle() {
        request('idle', SUGGEST_URL, {}, function (err, rs) {
          var idle = $scope.idle;
          idle.loading = false;
          idle.notice = null;
          if (!err && rs && rs.succeed) {
            idle.recent = Array.isArray(rs.recent) ? rs.recent : [];
            idle.trending = Array.isArray(rs.trending) ? rs.trending : [];
            idle.releasing = Array.isArray(rs.releasing_this_week) ? rs.releasing_this_week : [];
            examples = Array.isArray(rs.examples) ? rs.examples.filter(function (e) { return typeof e === 'string' && e; }) : [];
            idle.at = Date.now();
          } else {
            idle.recent = []; idle.trending = []; idle.releasing = [];
            // Flag off, or a hiccup: the plain empty state, never an alarming notice.
            idle.notice = null;
          }
          idle.loaded = true;
          if ($scope.view === 'idle') {
            applyIdle();
          }
        });
        $scope.idle.loading = true;
      }

      function runQuery() {
        var q = typed();
        if (!q) return;
        if (v2Down()) { runLegacy(q); return; }
        var params = { q: q };
        if ($scope.raw) params.raw = 1; else params.correct = 1;
        request('query', SUGGEST_URL, params, function (err, rs) {
          if (!err && rs && rs.succeed) {
            $scope.pending = false;
            applyQuery(rs, q);
          } else {
            // An answered {succeed:false, message} is the server's "v2 unavailable" signal.
            // Any v2 miss switches to the legacy pace: 60 s on the "unavailable" signal, 10 s on a
            // bare {succeed:false} (a hydration error) or a transport error, so a failing v2 never
            // doubles traffic or logs every prefix through the legacy endpoint.
            if (!err && rs && rs.succeed === false && rs.message) v2_down_until = Date.now() + V2_DOWN_MS;
            else v2_down_until = Math.max(v2_down_until, Date.now() + 10000);
            runLegacy(q);
          }
        });
      }

      // /search/suggest answered succeed:false (v2 read switch off, breaker open, engine down):
      // fall back to what the header had before ENG-370, the legacy suggestions endpoint.
      function runLegacy(q) {
        request('query', LEGACY_URL, { q: q, page: 0 }, function (err, rs) {
          $scope.pending = false;
          $scope.data = null;
          $scope.scope_opts = [];
          $scope.box_heading = 'Boxes';
          $scope.status = 'ready';
          var rows = (!err && rs && rs.succeed && Array.isArray(rs.data)) ? rs.data.slice(0, MAX_BOXES) : null;
          if (rows) {
            $scope.notice = null;
            $scope.data = { query: q, corrected_query: '', is_corrected: false, total: rows.length };
            $scope.box_opts = rows.map(function (r) {
              return decorateBox({
                id: r.id, slug: r.slug, name: r.name, box_image: r.box_image,
                sport_type_name: r.sport_type_name, box_type_name: r.box_type_name,
                release_text: r.release_date, avg_price: r.price, upcs: r.upcs
              }, { tokens: words(q), no_image: no_image, query: q });
            });
            $scope.announce = rows.length ? plural(rows.length, 'box', 'boxes') + ' found for ' + q + '.' : 'No boxes match ' + q + '.';
          } else {
            // Both the v2 answer and the legacy one failed: a quiet line, the search row stays.
            $scope.notice = { type: 'failed' };
            $scope.box_opts = [];
            $scope.announce = 'Suggestions are unavailable. Press Enter to search.';
          }
          $scope.fallback = true;
          // Always offered in a failure or fallback state, and Enter does the same.
          $scope.all_opt = { kind: 'all', label: 'Search for \u201c' + q + '\u201d \u2192' };
          rebuild();
        });
      }

      function applyQuery(rs, q) {
        var corrected = rs.is_corrected && rs.corrected_query ? rs.corrected_query : '';
        var shown = corrected || rs.query || q;
        var total = Number(rs.total_results) || 0;
        var boxes = Array.isArray(rs.boxes) ? rs.boxes : [];
        $scope.notice = null;
        $scope.fallback = false;
        $scope.data = {
          query: rs.query || q,
          corrected_query: corrected,
          is_corrected: !!corrected,
          total: total
        };
        var ctx = { tokens: words(shown), no_image: no_image, upc: rs.is_upc_match === true, query: rs.query || q };
        $scope.box_heading = 'Boxes';
        $scope.box_opts = boxes.map(function (b) { return decorateBox(b, ctx); });
        // A scope row opens the /search page filtered by sport id, the same results as Enter
        // narrowed to that sport (QA ENG-354 bug 1). While /search is not served (read switch
        // off) it opens /waxtracker/<sport slug>/all/all/all?q=, the one legacy page that narrows
        // by sport AND q. A row missing the id (or the slug, on the legacy route) would open
        // unfiltered results, so it is not shown.
        $scope.scope_opts = (rs.is_upc_match === true ? [] : (Array.isArray(rs.scopes) ? rs.scopes : []))
          .filter(function (s) {
            return results_page ? (typeof s.sport_id === 'number' && s.sport_id > 0) : (typeof s.sport_slug === 'string' && s.sport_slug);
          })
          .map(function (s) {
            return { kind: 'scope', query: shown, sport_id: s.sport_id, sport_slug: s.sport_slug, sport_name: s.sport_name, count_text: plural(s.count, 'box', 'boxes') };
          });
        if (boxes.length) {
          $scope.all_opt = { kind: 'all', label: 'See all ' + total.toLocaleString('en-US') + (total === 1 ? ' result' : ' results') + ' for “' + shown + '” →' };
        } else {
          $scope.all_opt = { kind: 'all', label: 'Search for “' + shown + '” anyway →' };
        }
        $scope.status = 'ready';
        $scope.announce = boxes.length
          ? plural(total, 'box', 'boxes') + ' found for ' + shown + '. Use the up and down arrow keys to choose, Enter to open.'
          : 'No boxes match ' + shown + '.';
        rebuild();
      }

      // ---------- input ----------

      $scope.onInput = function () {
        $timeout.cancel(debounce_timer);
        origin_kind = null;
        $scope.active = -1;
        $scope.raw = false;
        $scope.clear_error = '';
        if (!$scope.open) {
          $scope.open = true;
          addDim();
        }
        if (!typed()) {
          abortInflight();
          showIdle();
          return;
        }
        // Keep the previous rows (dimmed) while the next answer is on its way, but never an
        // empty or error state: those become skeleton rows until the response arrives.
        var keep_rows = $scope.view === 'query' && $scope.status === 'ready' && $scope.box_opts.length > 0 && !$scope.notice && !!$scope.data;
        $scope.view = 'query';
        $scope.pending = true;
        if (!keep_rows) $scope.status = 'loading';
        debounce_timer = $timeout(runQuery, v2Down() ? LEGACY_DEBOUNCE_MS : DEBOUNCE_MS);
      };

      $scope.openPanel = function () {
        if ($scope.open) return;
        $scope.open = true;
        addDim();
        if (typed()) {
          // pending: closed while the answer was on its way, so there is nothing to rebuild
          // from yet -- ask again instead of leaving the skeleton up (Nick's review, item 3).
          if ($scope.pending && $scope.raw) runQuery(); // keep a "Search instead" choice in flight
          else if ($scope.view !== 'query' || !$scope.data || $scope.pending) $scope.onInput();
          else rebuild();
        } else {
          showIdle();
        }
      };

      $scope.closePanel = function () {
        $timeout.cancel(debounce_timer);
        $scope.open = false;
        $scope.active = -1;
        $scope.active_id = undefined;
        removeDim();
      };

      $scope.onFocus = function () {
        if (suppress_open) return;
        $scope.openPanel();
      };

      // First touch of the field (pointer or focus) loads the idle data once, so the rotating
      // placeholder has its examples without a request on every page view. Not while the field
      // already holds a query (prefilled on /search): no idle state or placeholder shows then,
      // and clearing the field loads it through showIdle.
      $scope.warm = function () {
        if (typed()) return;
        if ($scope.view === 'idle' && !$scope.idle.loaded && !$scope.idle.loading) loadIdle();
      };

      $scope.clear = function () {
        $scope.q = '';
        origin_kind = null;
        abortInflight();
        $scope.active = -1;
        showIdle();
        if (input) input.focus();
      };

      $scope.hover = function (o) {
        if ($scope.pending) return;
        if ($scope.active !== o.idx) {
          $scope.active = o.idx;
          syncActive();
        }
      };

      $scope.onKeydown = function (e) {
        var key = e.key;
        var n = $scope.options.length;
        if (key === 'ArrowDown' || key === 'ArrowUp') {
          if (e.target !== input) return;
          e.preventDefault();
          if (!$scope.open) {
            $scope.openPanel();
            return;
          }
          if (!n) return;
          if (key === 'ArrowDown') $scope.active = ($scope.active + 1) % n;
          else $scope.active = $scope.active <= 0 ? n - 1 : $scope.active - 1;
          syncActive();
        } else if (key === 'Enter') {
          if (e.target !== input || e.isComposing) return;
          e.preventDefault();
          var o = $scope.options[$scope.active];
          // While an answer is pending the rows on screen are the previous query's: never open one.
          if ($scope.open && o && !$scope.pending) $scope.choose(o);
          else if (typed()) $scope.searchAll();
        } else if (key === 'Escape') {
          if ($scope.open) {
            e.preventDefault();
            $scope.closePanel();
            // The refocus (Esc pressed on a panel button) must not reopen the panel it just
            // closed. ng-focus runs on the digest queue, so the flag is cleared after it.
            if (input && document.activeElement !== input) {
              suppress_open = true;
              input.focus();
              $timeout(function () { suppress_open = false; });
            }
          } else if ($scope.q) {
            e.preventDefault();
            origin_kind = null;
            $scope.q = '';
            abortInflight();
            showIdle();
          }
        }
      };

      $scope.searchInstead = function () {
        $scope.raw = true;
        $scope.pending = true;
        $scope.status = 'loading';
        $timeout.cancel(debounce_timer);
        runQuery();
        if (input) input.focus();
      };

      // ---------- actions ----------

      // false while an earlier choice is still navigating: a second Enter before the page
      // changes would log the same search twice (QA ENG-354 bug 4). Cleared after
      // LEAVE_GUARD_MS in case the navigation never happens (Turbolinks error, same URL).
      function startLeaving() {
        var now = Date.now();
        if (now < leaving_until) return false;
        leaving_until = now + LEAVE_GUARD_MS;
        return true;
      }

      // The results page URL for q, plus extra params. raw=1 carries a "Search instead for"
      // choice to the results page (ENG-372), which would otherwise correct the very words the
      // visitor just kept.
      function resultsUrl(q, extra) {
        return search_url + (search_url.indexOf('?') === -1 ? '?' : '&') + 'q=' + encodeURIComponent(q) +
          (extra || '') + ($scope.raw ? '&raw=1' : '');
      }

      function go(q, kind, url) {
        if (!startLeaving()) return;
        logSubmit(q, kind);
        $scope.closePanel();
        if (input) input.blur();
        visit(url || resultsUrl(q));
      }

      // kind defaults to where the text came from: a trending chip, else a typed Enter / click.
      $scope.searchAll = function (kind) {
        var q = searchQuery();
        if (q) go(q, kind || origin_kind || 'enter');
      };

      $scope.choose = function (o) {
        switch (o.kind) {
          case 'recent':
            go(o.query, 'recent');
            break;
          case 'trending':
            // Fills the field, as the prototype does: the live results appear right under it.
            $scope.q = o.query;
            if (input) input.focus();
            $scope.onInput();
            origin_kind = 'trending';
            break;
          case 'scope':
            go(o.query, origin_kind || 'enter', results_page
              ? resultsUrl(o.query, '&sport=' + encodeURIComponent(o.sport_id))
              : '/waxtracker/' + encodeURIComponent(o.sport_slug) + '/all/all/all?q=' + encodeURIComponent(o.query) + '&sort_by_release_date=true');
            break;
          case 'all':
            $scope.searchAll();
            break;
          case 'box':
            if (!startLeaving()) break;
            var q = $scope.view === 'query' ? searchQuery() : '';
            logSubmit(q, 'box', { box_id: o.id });
            $scope.closePanel();
            if (input) input.blur();
            visit('/boxes/' + encodeURIComponent(o.slug));
            break;
        }
      };

      $scope.clearRecent = function () {
        $scope.clear_error = '';
        $http.delete(RECENT_URL, { headers: { 'X-CSRF-Token': csrfToken() || '', 'Accept': 'application/json' } })
          .then(function () {
            $scope.idle.recent = [];
            if ($scope.view === 'idle') applyIdle();
          }, function (resp) {
            var message = resp && resp.data && resp.data.message;
            $scope.clear_error = typeof message === 'string' && message ? message : 'We could not clear your recent searches.';
          });
      };

      // ---------- page dimmer ----------
      // A real element on <body>, not a pseudo-element or an ng-if: the nav is sticky with a
      // backdrop-filter, which would otherwise clip a fixed child to the nav.

      function addDim() {
        if (dim) return;
        dim = document.createElement('div');
        dim.className = 'ws-sd-dim';
        document.body.appendChild(dim);
      }

      function removeDim() {
        if (dim && dim.parentNode) dim.parentNode.removeChild(dim);
        dim = null;
      }

      root.addEventListener('ws-search:close', function () {
        if ($scope.open) $scope.$evalAsync($scope.closePanel);
      });

      // The /search page (ENG-372, SearchResultsCtrl) hands over the query it shows, read from
      // its own URL, so refining it needs no retyping. Only into an empty field (never over
      // what the visitor started typing), and only the model: no panel, no request until the
      // field is focused. The value arrives as a DOM event detail, never through markup.
      root.addEventListener('ws-search:prefill', function (e) {
        var q = e.detail && typeof e.detail.q === 'string' ? e.detail.q.slice(0, 200) : '';
        if (!q) return;
        $scope.$evalAsync(function () {
          if (!$scope.q) $scope.q = q;
        });
      });

      // Tabbing out of the component closes it; a press outside is handled once for the page.
      root.addEventListener('focusout', function (e) {
        if ($scope.open && e.relatedTarget && !root.contains(e.relatedTarget)) $scope.$evalAsync($scope.closePanel);
      });

      // ---------- rotating placeholder ----------

      if (input) {
        var rotate = window.setInterval(function () {
          if (!document.body.contains(root)) {
            window.clearInterval(rotate);
            removeDim();
            $scope.$destroy(); // drop this instance's watchers; its DOM is gone (Turbolinks visit)
            return;
          }
          if (!examples.length || $scope.q || document.activeElement === input) return;
          example_index = (example_index + 1) % examples.length;
          input.setAttribute('placeholder', 'Try “' + examples[example_index] + '”');
        }, PLACEHOLDER_MS);
        input.addEventListener('focus', function () {
          if (!$scope.q) input.setAttribute('placeholder', default_placeholder);
        });
      }
    }
  ]);
}).call(this);
